import { render, staticRenderFns } from "./SupplierOffer.vue?vue&type=template&id=b137f0a6"
import script from "./SupplierOffer.vue?vue&type=script&lang=js"
export * from "./SupplierOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports